import { addNearbyFeedTypeAndZoneId } from '@/domain/center/useCases/addFeedTypeAndZoneId'
import { getScore } from '@/domain/useCases/score/getScore'
import { removePriorityItemsFromCenters } from './dedupeCentersByPriority'
import { useStaticRandom } from '@/hooks/useStaticRandom'
import type { PrimaryFocus } from '@/domain/primaryFocus/constant'
import type {
  CenterData,
  CenterFeedPlacement,
  SearchState,
  Center
} from '@/types/models'
import type { PageType } from '@/types/models/PageType.model'

type DedupeAndScoreNearbyCenters = {
  consolidatedFeed: Partial<CenterData>[]
  adCenters: Partial<CenterData>[] | []
  nearbyCenters: Partial<CenterData>[] | []
  primaryFocusTerm: PrimaryFocus
  searchState: SearchState
  locationType: string
  pageType: PageType
  resultsToDisplay: number
}

export const dedupeAndScoreNearbyCenters = ({
  consolidatedFeed,
  adCenters,
  nearbyCenters,
  primaryFocusTerm,
  searchState,
  locationType,
  pageType,
  resultsToDisplay
}: DedupeAndScoreNearbyCenters): Partial<Center>[] => {
  const filteredNearbyCenters = removePriorityItemsFromCenters({
    listWithPriority: [
      ...consolidatedFeed,
      ...adCenters
    ] as CenterFeedPlacement[],
    listToRemoveFrom: nearbyCenters as CenterFeedPlacement[]
  })
    .map(addNearbyFeedTypeAndZoneId)
    .map((center) => {
      const staticRandom = useStaticRandom()()
      const score = getScore({
        center: center as Center,
        searchState,
        staticRandom,
        locationType,
        primaryFocus: primaryFocusTerm,
        pageType
      })

      return {
        ...center,
        score
      }
    })
    .splice(0, resultsToDisplay)
  return filteredNearbyCenters
}
